// extracted by mini-css-extract-plugin
export var card = "_m5-0";
export var content = "_m5-2";
export var details = "_m5-3";
export var icon = "_m5-1";
export var iconBlue = "_m5-5";
export var iconBrand = "_m5-4";
export var iconGrayBlue = "_m5-6";
export var iconGreen = "_m5-7";
export var iconIndigo = "_m5-8";
export var iconOrange = "_m5-9";
export var iconPurple = "_m5-a";
export var iconRed = "_m5-b";
export var iconWarning = "_m5-c";